import {MailerServiceProvider, PaginatedMailerServiceProvider} from '@app/modules/shared/models';

export interface IMailerServiceProviderState {
  mailerServiceProvider: MailerServiceProvider;
  mailerServiceProviders: MailerServiceProvider[];
  paginatedMailerServiceProviders: PaginatedMailerServiceProvider;
  success: string;
  error: string;
}

export const initialMailerServiceProviderState: IMailerServiceProviderState = {
  mailerServiceProvider: null,
  mailerServiceProviders: [],
  paginatedMailerServiceProviders: null,
  success: '',
  error: ''
};
